import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12c9b2fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entry_career_contents_wrapper" }
const _hoisted_2 = { class: "entry_career_indicator" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "entry_career_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "entry_career_title_text" }, "資格を教えてください")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "entry_career_text" }, "この項目は任意です", -1))
const _hoisted_5 = { class: "entry_career_input" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "運転免許")
], -1))
const _hoisted_7 = { class: "entry_career_input_layout_column_2" }
const _hoisted_8 = { class: "entry_career_input_layout_column_2_item" }
const _hoisted_9 = { class: "entry_career_input_layout_column_2_item" }
const _hoisted_10 = { class: "entry_career_input" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "資格と取得年月")
], -1))
const _hoisted_12 = { class: "entry_career_input_layout_column_1" }
const _hoisted_13 = { class: "entry_career_input_layout_column_1_item" }
const _hoisted_14 = { class: "entry_career_license_delete" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "entry_career_license_add" }
const _hoisted_17 = { class: "entry_career_button" }
const _hoisted_18 = { class: "entry_career_button_prev" }
const _hoisted_19 = { class: "entry_career_button_next" }
const _hoisted_20 = { class: "entry_career_skip" }

import { ref, computed } from 'vue';
import { useField, useForm, useFieldArray } from 'vee-validate';
import { object, string, array } from 'yup';
import BaseButton from '@/components/BaseButton.vue';
import BaseRadioButton from '@/components/BaseRadioButton.vue';
import BaseTextForm from '@/components/BaseTextForm.vue';
import BaseYmForm from '@/components/BaseYmForm.vue';
import Indicator from '@/components/Indicator.vue';
import Loading from '@/components/Loading.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import { validationRuleHelper } from '@/utils/validationRule';
import VALIDATON_ERRORS from '@/constants/validationErrors';
import { Qualification } from '@/types';
import router from '@/router';
import store from '@/store';
import { putUpdateCareerRegstatus } from '@/api/accountEndpoint';


export default /*#__PURE__*/_defineComponent({
  __name: 'SkilllicenseView',
  setup(__props) {

const isLoading = ref(false);

const schema = object({
  qualifications: array()
    .of(
      object().shape({
        qualdetails: string().label('資格名').required(VALIDATON_ERRORS.REQUIRED).max(100),
        qualym: string().label('取得年月').required(VALIDATON_ERRORS.REQUIRED),
      })
    )
    .strict(),
});

const { errors } = useForm({
  validationSchema: schema,
});

const qualificationsErrors = (index: number, formName: string) => {
  const error = errors.value[`qualifications[${index}].${formName}`];
  return error !== undefined ? [error] : [];
};

const qualymErrors = (qualym: string) => {
  const error = /^\d{4}-\d{2}/.test(qualym) ? [] : ['取得年月は必須です'];
  return error;
};

const { value: drLicenseFlg, errors: drLicenseFlgErrors } = useField<boolean>(
  'drLicenseFlg',
  validationRuleHelper({ requiredBoolean: true }),
  {
    initialValue: store.getters['careerSheetSkillLicense/drLicenseFlg'],
    bails: false,
    label: '運転免許',
  }
);

const {
  remove: qualificationsRemove,
  replace: qualificationsReplace,
  push: qualificationsPush,
  fields: qualifications,
} = useFieldArray<Qualification & { index: number; qualymTouched: boolean }>('qualifications');

let qualificationsIndex = 0;

const init = async () => {
  try {
    isLoading.value = true;
    await store.dispatch('careerSheetSkillLicense/getQualificationInfo');
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
  const qualifications = (store.getters['careerSheetSkillLicense/qualifications'] as Qualification[]).map((i) => {
    qualificationsIndex++;
    return { ...i, index: qualificationsIndex, qualymTouched: false };
  });
  qualificationsReplace(qualifications);
  drLicenseFlg.value = store.getters['careerSheetSkillLicense/drLicenseFlg'];
};
init();

const deleteQualification = (index: number) => {
  if (qualifications.value.length < 1) {
    return;
  }
  if (index > -1) {
    delete errors.value[`qualifications[${index}].qualdetails`];
    delete errors.value[`qualifications[${index}].qualym`];
    qualificationsRemove(index);
  }
};

const defaultQualification = {
  qualdetails: '',
  qualym: '',
  qualymTouched: false,
};

const addQualification = () => {
  qualificationsIndex++;
  qualificationsPush({ ...defaultQualification, index: qualificationsIndex });
};

const isError = computed(() => {
  if (qualifications.value.length === 0) return false;
  return qualifications.value.some((i) => {
    return !i.value.qualdetails || !/^\d{4}-\d{2}/.test(i.value.qualym);
  });
});

const transitionPreviousPage = () => {
  router.push({ name: 'c10' });
};

const transitionNextPage = async () => {
  isLoading.value = true;
  const param = {
    drLicenseFlg: drLicenseFlg.value,
    qualifications: qualifications.value.map((i) => {
      return {
        qualdetails: i.value.qualdetails,
        qualym: i.value.qualym,
      };
    }),
  };
  store.commit('careerSheetSkillLicense/set', param);
  try {
    isLoading.value = true;
    await store.dispatch('careerSheetSkillLicense/putQualificationInfo');
    router.push({ name: 'c12' });
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};

const updateCareerRegstatus = async() => {
  await putUpdateCareerRegstatus();
};


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Indicator, {
          current: 10,
          max: 12
        })
      ]),
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(BaseRadioButton, {
              label: "あり",
              name: "driving_license_os",
              value: true,
              modelValue: _unref(drLicenseFlg),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(drLicenseFlg) ? (drLicenseFlg).value = $event : null))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(BaseRadioButton, {
              label: "なし",
              name: "driving_license_os",
              value: false,
              modelValue: _unref(drLicenseFlg),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(drLicenseFlg) ? (drLicenseFlg).value = $event : null))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createVNode(ErrorMessage, { errors: _unref(drLicenseFlgErrors) }, null, 8, ["errors"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(qualifications), (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "entry_career_license",
          key: item.value.index
        }, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(BaseTextForm, {
                  maxlength: 100,
                  isError: qualificationsErrors(index, 'qualdetails').length > 0,
                  placeholder: "資格を入力",
                  modelValue: item.value.qualdetails,
                  "onUpdate:modelValue": ($event: any) => ((item.value.qualdetails) = $event)
                }, null, 8, ["isError", "modelValue", "onUpdate:modelValue"])
              ])
            ]),
            _createVNode(ErrorMessage, {
              errors: qualificationsErrors(index, 'qualdetails')
            }, null, 8, ["errors"]),
            _createVNode(BaseYmForm, {
              minYm: "1960-01",
              modelValue: item.value.qualym,
              "onUpdate:modelValue": ($event: any) => ((item.value.qualym) = $event),
              suffixMonthText: "月取得",
              yearSort: "desc",
              onFocusout: () => (item.value.qualymTouched = true)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocusout"]),
            (item.value.qualymTouched)
              ? (_openBlock(), _createBlock(ErrorMessage, {
                  key: 0,
                  errors: qualymErrors(item.value.qualym)
                }, null, 8, ["errors"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              class: "button_license_delete",
              onClick: ($event: any) => (deleteQualification(index))
            }, "資格を削除", 8, _hoisted_15)
          ])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_16, [
        (_unref(qualifications).length < 6)
          ? (_openBlock(), _createBlock(BaseButton, {
              key: 0,
              theme: "secondary",
              type: "button",
              onClick: addQualification
            }, {
              default: _withCtx(() => [
                _createTextVNode(" ＋資格を追加する（6つまで） ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createVNode(BaseButton, {
            onClick: transitionPreviousPage,
            theme: "tertiary",
            type: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("戻る")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(BaseButton, {
            theme: "primary",
            type: "button",
            disabled: _unref(isError),
            onClick: transitionNextPage
          }, {
            default: _withCtx(() => [
              _createTextVNode("保存して次へ")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_router_link, {
          class: "entry_career_skip_link",
          to: { name: 'd00' },
          onClick: updateCareerRegstatus
        }, {
          default: _withCtx(() => [
            _createTextVNode("入力せずに面談予約へ")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})